'use strict';

var _ = require('lodash');
var ChartFaresDataProviderService = function ChartFaresDataProviderService($q, dataRetrieverService, dataRetrieverConstants, configurationService, MomentService) {
  function mapClasses(serviceClassGroupConfig) {
    return _.chain(serviceClassGroupConfig).map('className').uniq().value();
  }
  function mapCabinClasses(serviceClassGroupConfig) {
    return _.chain(serviceClassGroupConfig).groupBy('cabinCode').mapValues(mapClasses).value();
  }
  function createCabinClassesMap() {
    var marketServiceClassGroupConfig = configurationService.getClassGroupConfig();
    return _.mapValues(marketServiceClassGroupConfig, mapCabinClasses);
  }
  function getCabinClassesByMarket(cabinClassesByMarketMap, marketName) {
    return cabinClassesByMarketMap[marketName] || cabinClassesByMarketMap["default"];
  }
  function groupByMarket(data) {
    return _.groupBy(data, 'market');
  }
  function createRegularElement(cabin, clazz, trafficDistribiution, avgFare, prevAvgFare) {
    avgFare = avgFare || undefined;
    prevAvgFare = prevAvgFare || undefined;
    var avgFareCircle = [];
    if (prevAvgFare) {
      avgFareCircle.push({
        css: 'prev-traffic-circle',
        value: prevAvgFare
      });
    }
    if (avgFare) {
      avgFareCircle.push({
        css: 'traffic-circle',
        value: avgFare
      });
    }
    return {
      cabin: cabin,
      clazz: clazz,
      data: trafficDistribiution,
      avgFare: avgFare,
      prevAvgFare: prevAvgFare,
      avgFareCircle: avgFareCircle
    };
  }
  function groupDataByClassAndMonths(dataFromServer) {
    var finalResult = {};
    var trafficDistribiutionByMonth;
    var groupedByMarket = groupByMarket(dataFromServer.revenueAccounting);
    var avgFaresByMarket = groupByMarket(dataFromServer.averageFares);
    var prevAvgFaresByMarket = groupByMarket(dataFromServer.prevAverageFares);
    var cabinClassesByMarketMap = createCabinClassesMap();
    _.forEach(groupedByMarket, function (dataForMarket, marketName) {
      var dataByCabin = {};
      var groupedByClassName = _.groupBy(dataForMarket, 'className');
      var avgFaresByCassName = _.groupBy(avgFaresByMarket[marketName], 'className');
      var prevAvgFaresByCassName = _.groupBy(prevAvgFaresByMarket[marketName], 'className');
      var cabinClasses = getCabinClassesByMarket(cabinClassesByMarketMap, marketName);
      _.forEach(cabinClasses, function (classList, cabin) {
        var result = [];
        _.forEach(classList, function (clazz) {
          var dataForClazz = groupedByClassName[clazz];
          var avgFaresForClass = avgFaresByCassName[clazz];
          var prevAvgFaresForClass = prevAvgFaresByCassName[clazz];
          trafficDistribiutionByMonth = [];
          for (var monthIdx = 0; monthIdx < 12; monthIdx++) {
            var finded = _.filter(dataForClazz, {
              month: monthIdx + 1
            });
            if (finded && finded.length) {
              trafficDistribiutionByMonth[monthIdx] = finded[0].traffic;
            } else {
              trafficDistribiutionByMonth[monthIdx] = 0;
            }
          }
          var avgFare = _.chain(avgFaresForClass).map('totalFare').filter(_.isNumber).mean().value();
          var prevAvgFare = _.chain(prevAvgFaresForClass).map('totalFare').filter(_.isNumber).mean().value();
          avgFare = _.mean(trafficDistribiutionByMonth) && avgFare;
          prevAvgFare = _.mean(trafficDistribiutionByMonth) && prevAvgFare;
          result.push(createRegularElement(cabin, clazz, trafficDistribiutionByMonth, avgFare, prevAvgFare));
        });
        dataByCabin[cabin] = result;
      });
      finalResult[marketName] = dataByCabin;
    });
    var noRaDataMarkets = [];
    _.keys(avgFaresByMarket).forEach(function (item) {
      if (!finalResult[item]) {
        noRaDataMarkets.push(item);
      }
    });
    return {
      groupedData: finalResult,
      noRaDataMarkets: noRaDataMarkets
    };
  }
  function calculatePrevAvgFaresEventTimeStamp(currentAverageFaresData) {
    return _.chain(currentAverageFaresData).map(function (d) {
      return MomentService.of(d.effectiveTimeStamp, MomentService.FIELD.EFFECTIVE_TIME_STAMP);
    }).uniq().sortBy().takeRight().map(function (effectiveTimeStamp) {
      return effectiveTimeStamp.subtract(1, 'minute').toISOString();
    }).value();
  }
  function retrieveAverageFaresData(averageFaresData) {
    var prevAvgFaresEffectiveTimeStamp = calculatePrevAvgFaresEventTimeStamp(averageFaresData);
    if (prevAvgFaresEffectiveTimeStamp && prevAvgFaresEffectiveTimeStamp.length > 0) {
      var futurePrevFaresDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstants.FARES_SCREEN, dataRetrieverConstants.FARES_PREV_AVERAGE_MODE).resetCustomSearchCriteriaRules();
      futurePrevFaresDataRetriever.defaultSortDefer.resolve();
      return $q.all({
        averageFares: averageFaresData,
        prevAverageFares: futurePrevFaresDataRetriever.setRequestParameters({
          'eventTimeStamp': prevAvgFaresEffectiveTimeStamp
        }).retrieveComponentData('fares-average-prev')
      });
    } else {
      return {
        averageFares: averageFaresData,
        prevAverageFares: averageFaresData
      };
    }
  }
  function getData() {
    var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstants.FARES_SCREEN, dataRetrieverConstants.FARES_CHART_MODE);
    var futureFaresDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstants.FARES_SCREEN, dataRetrieverConstants.FARES_AVERAGE_MODE).resetCustomSearchCriteriaRules();
    dataRetriever.defaultSortDefer.resolve();
    return $q.all({
      revenueAccounting: dataRetriever.retrieveComponentData('fares-class-usage-chart'),
      averageFares: futureFaresDataRetriever.retrieveComponentData('fares-average').then(retrieveAverageFaresData)
    }).then(function (data) {
      return {
        revenueAccounting: data.revenueAccounting,
        averageFares: _.get(data.averageFares, 'averageFares'),
        prevAverageFares: _.get(data.averageFares, 'prevAverageFares')
      };
    }).then(groupDataByClassAndMonths);
  }
  return {
    getData: getData
  };
};
ChartFaresDataProviderService.$inject = ['$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'ConfigurationService', 'MomentService'];
module.exports = ChartFaresDataProviderService;